// src/pages/PublishBlog.jsx
import {useState} from "react";
import {supabase} from "../../services/supabase";
import BlogEditor from "./BlogEditor";

export default function PublishBlog() {
    const [title, setTitle] = useState("");
    const [content, setContent] = useState([
        {
            type: "paragraph",
            children: [{ text: "Hello there write here" }],
        },
    ]);
    const [image, setImage] = useState(null);
    const [success, setSuccess] = useState(false);
    const [uploading, setUploading] = useState(false);

    const handleImageChange = (e) => {
        const file = e.target.files[0];

        if (!file) return;

        const validTypes = ["image/jpeg", "image/png", "image/webp"];
        const maxSize = 2 * 1024 * 1024; // 2MB

        if (!validTypes.includes(file.type)) {
            alert("Only JPEG, PNG, and WEBP images are allowed.");
            return;
        }

        if (file.size > maxSize) {
            alert("Image size should be less than 2MB.");
            return;
        }

        setImage(file);
    };
    const generateSlug = (title) =>
        title
            .toLowerCase()
            .trim()
            .replace(/[^a-z0-9\s-]/g, "")       // Remove special characters
            .replace(/\s+/g, "-")               // Replace spaces with dashes
            .replace(/-+/g, "-")                // Collapse multiple dashes
            .replace(/^-+|-+$/g, "");           // Trim dashes from start/end

    const slug = generateSlug(title);

    const handleSubmit = async (e) => {

        e.preventDefault();
        setUploading(true);
        const { data: sessionData, error: sessionError } = await supabase.auth.getSession();
        const user = sessionData?.session?.user;


        if (!user || user.user_metadata?.role !== "admin") {
            alert("Unauthorized: Only admins can publish blogs.");
            setUploading(false);
            return;
        }
        if (sessionError) {
            console.error(sessionError);
            setUploading(false);
            return;
        }



        let imageUrl = "";

        if (image) {
            const fileExt = image.name.split(".").pop();
            const fileName = `thumbnails/${Date.now()}.${fileExt}`;
            //removed data below
            const { error: uploadError } = await supabase.storage
                .from("blog-images")
                .upload(fileName, image);

            if (uploadError) {
                console.error(uploadError);
                setUploading(false);
                return;
            }

            const { data: publicUrlData } = supabase.storage
                .from("blog-images")
                .getPublicUrl(fileName);
            // removed files below
            // const { data: files } = await supabase
            //     .storage
            //     .from('blog-images')
            //     .list('thumbnails');


            imageUrl = publicUrlData.publicUrl;
        }

        const { error } = await supabase.from("blogs").insert({
            title,
            content: JSON.stringify(content),
            thumbnail_url: imageUrl,
            user_id:user?.id,
            slug
        });

        if (error) {
            console.error(error);
        } else {
            setSuccess(true);
        }
        setUploading(false);
        setTitle("");
        setImage(null);
        setContent([
            {
                type: "paragraph",
                children: [{ text: "Hello there write here" }],
            },
        ])
    };

    return (
        <div className="w-full bg-white rounded-lg p-1 sm:p-6">
            <h2 className="text-3xl font-bold text-gray-900 mb-8">Publish New Blog Post</h2>
            <form onSubmit={handleSubmit}>
                <div className="mb-6">
                    <label className="block mb-2 text-sm font-semibold text-gray-900">Blog Title</label>
                    <input
                        type="text"
                        name="title"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                        placeholder="Enter your blog title"
                        className="w-full py-3 px-4 border border-gray-200 rounded-lg text-sm text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-orange-600 focus:border-orange-600"
                        required
                    />
                </div>

                <div className="mb-6">
                    <label className="block mb-2 text-sm font-semibold text-gray-900">Featured Image</label>
                    <input
                        type="file"
                        accept="image/*"
                        onChange={handleImageChange}
                        className="w-full py-3 px-4 border border-gray-200 rounded-lg text-sm text-gray-900"
                    />
                    {image && (
                        <img loading="lazy"
                            src={URL.createObjectURL(image)}
                            alt="Preview"
                            className="mt-4 h-48 w-full object-cover rounded"
                        />
                    )}
                </div>

                <div className="mb-6">

                    <BlogEditor content={content} setContent={setContent}/>
                </div>

                <div className="flex flex-col sm:flex-row gap-4 sm:justify-end">

                    <button
                        type="submit"
                        className="py-3 px-6 text-sm font-semibold text-white bg-orange-900 hover:bg-orange-800 rounded-md transition duration-300"
                        disabled={uploading}
                    >
                        {uploading ? "Publishing..." : "Publish Blog"}
                    </button>
                </div>
            </form>

            {success && (
                <div className="mt-6 p-4 bg-green-100 border border-green-400 text-green-700 rounded-lg">
                    <p className="font-semibold">Success!</p>
                    <p>Your blog post has been published successfully.</p>
                </div>
            )}
        </div>
    );
}